import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuContent from './MenuContent';
import { useAuth } from '../AuthProvider';
import { Button } from '@mui/material';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export default function SideMenu() {
  const auth = useAuth();
  function GetEmailBeforeAt(email: string | null): string {
    if (email === null) return "";
    return email.split('@')[0];
  }

  return (
    <Drawer
      variant="permanent"
      sx={{
        // display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <MenuContent />
      </Box>
      <Box
        sx={{
          p: 1,
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Button href='/app/profile' sx={{height: '60px', width: 1}}>
          <Stack direction="row"
            sx={{
              gap: 1,
              justifyContent: 'center',
              width: 1
            }}>
            <Avatar
              sizes="small"
              alt=""
              src=""
              sx={{ width: 36, height: 36 }}
            />
            <Stack sx={{ gap: "4px", width: '160px'}}>
              <Typography noWrap variant="body2" sx={{width: 1, fontWeight: 500, lineHeight: '16px', textAlign: 'left' }}>
                {auth.currentUser?.displayName === null ? GetEmailBeforeAt(auth.currentUser?.email) : auth.currentUser?.displayName}
              </Typography>
              <Typography noWrap sx={{width: 1, fontSize: '0.7rem', color: 'text.secondary', textAlign: 'left' }}>
                {auth.currentUser?.email}
              </Typography>
            </Stack>
          </Stack>
        </Button>
      </Box>
    </Drawer >
  );
}
